import React, { useRef, useState } from "react";
import { Box } from "@mui/material";
import { update2FAType } from "api/api_register2FA";
import Swal from "sweetalert2";
import { clearLocalStorage } from "utils/storage";
import microphone from "../../../assets/images/icons/microphone.svg";

function Register2FAVoice() {
  const API_BASE_URL = process.env.REACT_APP_BASE_URL_PYTHON;
  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const user = JSON.parse(localStorage.getItem("user"));

  const update2FA = async (typeFA) => {
    await update2FAType(user.username, typeFA);
  };

  const handleMicClick = async () => {
    const apiUrl = `${API_BASE_URL}/upload_voice?text=${user.username}`;
    if (isRecording) {
      // Stop recording
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    } else {
      // Start recording
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const mediaRecorder = new MediaRecorder(stream);
        mediaRecorderRef.current = mediaRecorder;
        audioChunksRef.current = [];

        mediaRecorder.ondataavailable = (event) => {
          audioChunksRef.current.push(event.data);
        };

        mediaRecorder.onstop = async () => {
          const audioBlob = new Blob(audioChunksRef.current, { type: "audio/wav" });
          const formData = new FormData();
          formData.append("file", audioBlob, "recording.wav");
          formData.append("text", "recording");

          try {
            const response = await fetch(apiUrl, {
              method: "POST",
              body: formData,
            });

            if (!response.ok) {
              throw new Error("Failed to upload audio");
            }

            const data = await response.json();
            if (data.file) {
              update2FA(8);
              Swal.fire({
                title: "Xác minh 2 bước đã được bật",
                icon: "success",
              });
              setTimeout(() => {
                clearLocalStorage();
                window.location.href = "/authentication/sign-in";
              }, 1500);
            }
          } catch (error) {
            console.error("Error uploading audio:", error);
          }
        };

        mediaRecorder.start();
        setIsRecording(true);
      } catch (err) {
        console.error("Error accessing microphone", err);
      }
    }
  };

  return (
    <Box width={460} height={315} className="form-container">
      <Box className="fs-20 fw-700">Xác thực qua giọng nói</Box>
      <Box className="fs-14 gray-80 txt-align">Nhấn vào microphone để bắt đầu ghi âm</Box>
      <Box className="microphone-container" onClick={handleMicClick}>
        <div className={`microphone-icon ${isRecording ? "recording-active" : ""}`}>
          <img src={microphone} alt="Microphone Icon" />
        </div>
      </Box>

      <Box className="instruction">{isRecording ? "Đang ghi âm..." : "Nhấn để ghi âm"}</Box>
    </Box>
  );
}

export default Register2FAVoice;
